import React from "react";
import { connect } from "react-redux";
import { NavItem } from "reactstrap";
import api from "./../../Api.js";
import { formatXp } from "./../../helper/xpHelpers.js";

/**
 * HeaderGameStats — XP e gold do jogador no header, sempre visíveis.
 * Clicar leva pro personagem (/game/personagem).
 * Atualiza em tempo real pelos eventos de socket do RPG.
 */
class HeaderGameStats extends React.Component {

  constructor(props) {
    super(props);
    this.state = { xp: null, gold: null, level: null, pct: 0, falta: null, proximo: null, pulse: null };
    this.reload = this.reload.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.reload();
    this.bindSocket();
    //rede de seguranca: a navbar nao remonta ao navegar, entao um refresh
    //periodico cobre ganhos que nao vieram por socket (ex: aba em background)
    this.pollTimer = setInterval(this.reload, 60000);
  }

  //a navbar monta antes do usuario chegar no redux — recarrega quando ele chega
  componentDidUpdate(prevProps) {
    var antes = prevProps.user && prevProps.user.id;
    var agora = this.props.user && this.props.user.id;
    if (!antes && agora) this.reload();
  }

  componentWillUnmount() {
    this.mounted = false;
    this.unbindSocket();
    if (this.pulseTimer) clearTimeout(this.pulseTimer);
    if (this.socketTimer) clearTimeout(this.socketTimer);
    if (this.pollTimer) clearInterval(this.pollTimer);
  }

  //id do usuario: redux ou, se ainda nao carregou, a sessao
  getUserId() {
    if (this.props.user && this.props.user.id) return this.props.user.id;
    var sid = sessionStorage.getItem('userId');
    return sid ? parseInt(sid) : null;
  }

  bindSocket() {
    //o socket global e criado depois do primeiro render — tenta de novo
    if (!window.socket) {
      if (this.mounted) this.socketTimer = setTimeout(() => this.bindSocket(), 3000);
      return;
    }
    var self = this;
    this.onXp = function () { self.reload('xp'); };
    this.onGold = function () { self.reload('gold'); };
    //garante a room do usuario (e reentra a cada reconexao — rooms se perdem)
    this.joinRoom = function () {
      var uid = self.getUserId();
      if (uid && window.socket) window.socket.emit('join-user', { user: uid });
    };
    this.onConnect = function () { self.joinRoom(); self.reload(); };

    this.joinRoom();
    window.socket.on('connect', this.onConnect);
    window.socket.on('rpg:xp-gained', this.onXp);
    window.socket.on('rpg:gold-gained', this.onGold);
    window.socket.on('rpg:gold-lost', this.onGold);
  }

  unbindSocket() {
    if (!window.socket) return;
    if (this.onConnect) window.socket.off('connect', this.onConnect);
    if (this.onXp) window.socket.off('rpg:xp-gained', this.onXp);
    if (this.onGold) {
      window.socket.off('rpg:gold-gained', this.onGold);
      window.socket.off('rpg:gold-lost', this.onGold);
    }
  }

  async reload(pulse) {
    var userId = this.getUserId();
    if (!userId) return;
    try {
      var res = await api.getRpgStatus(userId);
      var d = res.data || {};
      this.setState({
        xp: d.xp ? d.xp.totalXp : 0,
        level: d.xp && d.xp.currentLevel ? d.xp.currentLevel : null,
        pct: d.xp && typeof d.xp.percentToNext === 'number' ? d.xp.percentToNext : 0,
        falta: d.xp ? d.xp.xpToNextLevel : null,
        proximo: d.xp && d.xp.nextLevel ? d.xp.nextLevel : null,
        gold: d.gold ? d.gold.balance : 0
      });
      if (pulse) {
        this.setState({ pulse: pulse });
        if (this.pulseTimer) clearTimeout(this.pulseTimer);
        this.pulseTimer = setTimeout(() => this.setState({ pulse: null }), 1200);
      }
    } catch (e) { /* sem gamificação pro usuário: widget fica oculto */ }
  }

  go(e) {
    e.preventDefault();
    if (this.props.history) this.props.history.push('/game/personagem');
    else window.location.href = '/game/personagem';
  }

  render() {
    if (this.state.xp === null && this.state.gold === null) return null;

    var level = this.state.level;
    var pillBase = {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '5px',
      background: 'rgba(255,255,255,0.18)',
      borderRadius: '20px',
      padding: '4px 11px',
      fontWeight: 700,
      fontSize: '0.8rem',
      color: '#fff',
      lineHeight: 1,
      transition: 'transform 0.25s, background 0.25s'
    };

    var pulseStyle = { transform: 'scale(1.14)', background: 'rgba(255,255,255,0.35)' };

    return (
      <NavItem className="d-none d-md-block">
        <a
          href="/game/personagem"
          onClick={(e) => this.go(e)}
          className="nav-link px-2"
          title={
            'Meu Personagem'
            + (level ? ' · Nível ' + level.level + ' ' + level.name : '')
            + (this.state.falta ? ' · faltam ' + this.state.falta + ' XP pro ' + (this.state.proximo ? this.state.proximo.name : 'próximo nível') : '')
          }
          style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}
        >
          {/* XP: barra de progresso ate o proximo nivel */}
          <span style={Object.assign({}, pillBase, {
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: '2px',
            minWidth: '104px',
            padding: '4px 10px'
          }, this.state.pulse === 'xp' ? pulseStyle : {})}>
            <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '6px', fontSize: '0.72rem' }}>
              <span>
                <i className="fas fa-bolt mr-1" style={{ color: '#FFD700' }} />
                {level ? 'Nv ' + level.level : 'XP'}
              </span>
              <span>{formatXp(this.state.xp || 0)}</span>
            </span>
            <span style={{
              display: 'block',
              height: '4px',
              borderRadius: '3px',
              background: 'rgba(0,0,0,0.25)',
              overflow: 'hidden'
            }}>
              <span style={{
                display: 'block',
                height: '100%',
                width: Math.max(2, Math.min(100, this.state.pct || 0)) + '%',
                borderRadius: '3px',
                background: 'linear-gradient(90deg, #FFD700 0%, #FFA000 100%)',
                transition: 'width 0.5s ease'
              }} />
            </span>
          </span>
          <span style={Object.assign({}, pillBase, this.state.pulse === 'gold' ? pulseStyle : {})}>
            <i className="fas fa-coins" style={{ color: '#FFC107' }} />
            {(this.state.gold || 0).toLocaleString('pt-BR')}
          </span>
        </a>
      </NavItem>
    );
  }
}

export default connect(state => ({ user: state.user }))(HeaderGameStats);
